import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useAppContext } from "../../../context";
import { useNavigate } from 'react-router-dom'
import Live from "./Live";
import { apiUrl } from "../../../utils/config";


const BOT_RESPONSES = {
  greeting: "Hey there! 👋 I'm Gampa, your personal food assistant. Ask me anything about our menu, delivery, or your order!",
  menu: "We have 50+ authentic South Indian dishes across Breakfast, Dinner, Sides, Snacks, Desserts & Beverages. 🍽️ Head to our Menu page to explore everything!",
  order: "To place an order: browse the Menu → add items to your cart → checkout in under 60 seconds! We accept Card, UPI and Cash on Delivery. 🛒",
  delivery: "We deliver in 25–35 minutes across Hyderabad! 🚀 Orders above $30 get free delivery. Otherwise it's just $3.99.",
  price: "Prices range from $2 (steamed rice) to $20 (Chettinad curry). Most dishes are under $15. Great value for authentic food!",
  popular: "Our top 3 right now: 🥇 Chicken Biryani, 🥈 Masala Dosa, 🥉 Filter Coffee. All three are absolutely worth trying!",
  hours: "We're open 7 days a week from 7:00 AM to 11:00 PM. ⏰ Last order at 10:45 PM.",
  veg: "We have 9 out of 12 items as vegetarian — all Breakfast, Desserts, Beverages and most Sides. Look for the 🟢 green dot on cards!",
  spicy: "We mark spice levels from 0–4 chilli dots on every card. Masala Dosa is mild, Chettinad Curry is very spicy 🔥. You decide!",
  track: "You can track your order in real time from your Profile → Orders. You'll also get SMS updates at every stage. 📍",
  default: "Great question! I'd love to help — you can also reach our team at hello@gamapafoods.com or call +91 98765 43210. 😊",
};

export const Chatbot = ({ }) => {
  const { setIsCartOpen,updateQty } = useAppContext();
   const navigate = useNavigate()
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState("chat");
  const [msgs, setMsgs] = useState([{ id: 1, from: "bot", text: BOT_RESPONSES.greeting, time: "now" }]);
  const [input, setInput] = useState("");
  const [typing, setTyping] = useState(false);
  const [voiceState, setVoiceState] = useState("idle"); // idle|listening|processing|speaking
  const [transcript, setTranscript] = useState("");
  const endRef = useRef(null);

  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [msgs]);

  const getReply = (text) => {
    const t = text.toLowerCase();
    if (/hi|hello|hey|howdy/.test(t)) return BOT_RESPONSES.greeting;
    if (/menu|food|dish|eat|item/.test(t)) return BOT_RESPONSES.menu;
    if (/order|buy|cart|checkout/.test(t)) return BOT_RESPONSES.order;
    if (/deliver|time|fast|quick|long/.test(t)) return BOT_RESPONSES.delivery;
    if (/price|cost|how much|cheap|value/.test(t)) return BOT_RESPONSES.price;
    if (/popular|best|top|recommend|good/.test(t)) return BOT_RESPONSES.popular;
    if (/hour|open|close|timing|available/.test(t)) return BOT_RESPONSES.hours;
    if (/veg|vegetarian/.test(t)) return BOT_RESPONSES.veg;
    if (/spic|hot|mild|chilli/.test(t)) return BOT_RESPONSES.spicy;
    if (/track|status|where/.test(t)) return BOT_RESPONSES.track;
    return BOT_RESPONSES.default;
  };

  const send = async () => {
    if (!input.trim()) return;
    setInput("");
    setTyping(true);
    /* const u = {id:Date.now(), from:"user", text:input, time:new Date().toLocaleTimeString([],{hour:"2-digit",minute:"2-digit"})};
    setMsgs(p=>[...p,u]);
    setInput("");
    setTyping(true);
    setTimeout(() => {
      setTyping(false);
      setMsgs(p=>[...p,{id:Date.now()+1, from:"bot", text:getReply(u.text), time:new Date().toLocaleTimeString([],{hour:"2-digit",minute:"2-digit"})}]);
    }, 1000+Math.random()*600); */

    try {
      setMsgs((prevMessages) => [
        ...prevMessages,
        {
          id: msgs.length + 1,
          from: "user",
          text: input
        }]);

      const response = await axios.post(
        apiUrl+"/ai/intent",
        {
          message: input
        }
      );

      // call api for what you need 
      if (response.data && response.data.status) {
        if(response.data.result.intent == "checkout"){
 navigate("/checkout")
 setOpen(false)
        }else{

      
        const finalRes = await axios.post(
          apiUrl+"/ai/intent-router",{
            intent: response.data?.result?.intent,
            message: input
          }
        );
        setTyping(false);
        if(finalRes && finalRes.data && finalRes.data.result){
          if(finalRes.data.intent == "cartAction"){
            updateQty(finalRes.data.productId,1)
            //setIsCartOpen(true)
          }
          setMsgs((prevMessages) => [
            ...prevMessages,
            {
              id: msgs.length + 1,
              text:finalRes.data.result
            }
          ]);
        }else{
          setMsgs((prevMessages) => [
            ...prevMessages,
            {
              id: msgs.length + 1,
              text:"try again later"
            }
          ]);
        }
          }
      } else {
        setTyping(false);
        setMsgs((prevMessages) => [
          ...prevMessages,
          {
            id: msgs.length + 1,
            text: "try again "
          }
        ]);
      } 

    } catch (error) {
      setTyping(false);
      console.error("Error:", error);
      setMsgs((prevMessages) => [
        ...prevMessages,
        {
          id: msgs.length + 1,
          text: "try again "
        }
      ]);
    }


  };

  const startVoice = () => {
    setVoiceState("listening");
    setTranscript("");
    const samples = ["What are your most popular dishes?", "How long does delivery take?", "Do you have vegetarian options?", "What is the cheapest item on the menu?"];
    setTimeout(() => {
      const t = samples[Math.floor(Math.random() * samples.length)];
      setTranscript(t);
      setVoiceState("processing");
      setTimeout(() => {
        const reply = getReply(t);
        setMsgs(p => [...p, { id: Date.now(), from: "user", text: t, time: "now", voice: true }, { id: Date.now() + 1, from: "bot", text: reply, time: "now" }]);
        setVoiceState("speaking");
        setTimeout(() => setVoiceState("idle"), 3000);
      }, 900);
    }, 2500);
  };

  const quickReplies = ["Popular dishes?", "Delivery time?", "Veg options?", "Today's specials?", "Track my order"];

  return (
    <>
      {/* Launcher */}
      <div className="fixed bottom-6 right-6 z-50">
        <button onClick={() => setOpen(!open)} className={`relative w-14 h-14 rounded-2xl shadow-2xl flex items-center justify-center transition-all btn-press ${open ? "bg-gray-800 rotate-6" : "bg-gradient-to-br from-[#f97316] to-red-500"}`}>
          <span className="text-2xl text-white">{open ? "✕" : "🤖"}</span>
          {!open && <span className="absolute -top-1 -right-1 w-3.5 h-3.5 bg-green-400 rounded-full border-2 border-white" />}
        </button>
        {!open && <div className="absolute -top-10 right-16 bg-gray-900 text-white text-xs font-bold px-3 py-1.5 rounded-full whitespace-nowrap shadow-lg pointer-events-none">Ask Gampa AI 👆</div>}
      </div>

      {/* Chat Window */}
      {open && (
        <div className="fixed bottom-24 right-6 z-50 w-80 bg-white rounded-3xl shadow-2xl shadow-gray-300/50 flex flex-col overflow-hidden border border-gray-100 afu" style={{ height: "520px" }}>
          {/* Header */}
          <div className="bg-gradient-to-r from-[#f97316] to-red-500 p-4 flex-shrink-0">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 bg-white/20 rounded-xl flex items-center justify-center text-xl">🤖</div>
              <div className="flex-1">
                <p className="font-bold text-white text-sm">Gampa AI</p>
                <p className="text-xs text-orange-100 flex items-center gap-1"><span className="w-1.5 h-1.5 bg-green-300 rounded-full" />Always online</p>
              </div>
            </div>
            <div className="flex bg-white/20 rounded-xl p-1">
              {[["chat", "💬 Chat"], ["voice", "🎤 Voice"]].map(([m, l]) => (
                <button key={m} onClick={() => setMode(m)} className={`flex-1 py-1.5 rounded-lg text-xs font-bold transition-all ${mode === m ? "bg-white text-[#f97316]" : "text-white/80 hover:text-white"}`}>{l}</button>
              ))}
            </div>
          </div>

          {/* CHAT MODE */}
          {mode === "chat" && (
            <>
              <div className="flex-1 overflow-y-auto p-3 space-y-2.5 thin-scroll">
                {msgs.map(m => (
                  <div key={m.id} className={`flex ${m.from === "user" ? "justify-end" : "justify-start"} items-end gap-1.5 afu`}>
                    {m.from === "bot" && <div className="w-6 h-6 rounded-lg bg-gradient-to-br from-[#f97316] to-red-400 flex items-center justify-center text-white text-[10px] flex-shrink-0 mb-0.5">🤖</div>}
                    <div className={`max-w-[80%] rounded-2xl px-3.5 py-2.5 text-xs leading-relaxed
                      ${m.from === "user" ? "bg-gradient-to-r from-[#f97316] to-red-500 text-white rounded-br-sm" : "bg-gray-100 text-gray-800 rounded-bl-sm"}`}>
                      {m.voice && <div className="text-[9px] opacity-60 font-bold mb-0.5">🎤 voice</div>}
                      {m.text}
                    </div>
                  </div>
                ))}
                {typing && (
                  <div className="flex items-end gap-1.5">
                    <div className="w-6 h-6 rounded-lg bg-gradient-to-br from-[#f97316] to-red-400 flex items-center justify-center text-white text-[10px] flex-shrink-0">🤖</div>
                    <div className="bg-gray-100 rounded-2xl rounded-bl-sm px-3.5 py-3 flex gap-1">
                      {[0, 1, 2].map(i => <div key={i} className="w-1.5 h-1.5 bg-gray-400 rounded-full" style={{ animation: `bounce3 1.2s ease ${i * 0.2}s infinite` }} />)}
                    </div>
                  </div>
                )}
                <div ref={endRef} />
              </div>

              {/* Quick Replies */}
              { /* <div className="px-3 pb-2 flex gap-1.5 overflow-x-auto no-scroll flex-shrink-0">
                {quickReplies.map(q => (
                  <button key={q} onClick={() => { setInput(q); setTimeout(() => { const u={id:Date.now(),from:"user",text:q,time:"now"}; setMsgs(p=>[...p,u]); setTyping(true); setTimeout(() => { setTyping(false); setMsgs(p=>[...p,{id:Date.now()+1,from:"bot",text:getReply(q),time:"now"}]); }, 900); }, 50); setInput(""); }}
                    className="flex-shrink-0 text-[10px] bg-orange-50 text-[#f97316] border border-orange-200 px-2.5 py-1 rounded-full font-bold hover:bg-orange-100 transition-colors whitespace-nowrap">{q}</button>
                ))}
              </div> */ }

              <div className="p-3 border-t border-gray-100 flex-shrink-0">
                <div className="flex gap-2">
                  <input value={input} onChange={e => setInput(e.target.value)} onKeyDown={e => e.key === "Enter" && send()} placeholder="Ask anything..." className="flex-1 text-xs px-3 py-2.5 border border-gray-200 rounded-xl bg-gray-50" />
                  <button onClick={send} disabled={!input.trim()} className="w-9 h-9 bg-gradient-to-r from-[#f97316] to-red-500 text-white rounded-xl flex items-center justify-center font-black disabled:opacity-30 hover:scale-105 transition-transform btn-press">↑</button>
                </div>
              </div>
            </>
          )}

          {/* VOICE MODE */}
          {mode === "voice" && (
          <>
            <Live />
          </>
          )}
        </div>
      )}
    </>
  );
};